import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const asyncTransitionBenefitsModal = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-jira-issue-transition-benefits-modal" */ './ui/index'),
	),
	getPreloadProps: () => ({}),
});
